(function() {
    'use strict';

    angular
        .module('app')
        .directive('menuToolbar', menuToolbar);

    menuToolbar.$inject = ['$window'];
    
    function menuToolbar ($window) {
        // Usage:
        //     <menuToolbar></menuToolbar>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {

        }
    }

})();